import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AlertComponent } from "../component/alert/alert.component";

/** A background task that just finished: what it was, what happened, and a link to see it. */
export interface AlertResult {
  tone: "success" | "warning" | "error";
  title: string;
  detail?: string;
  actionLabel?: string;
  action?: () => void;
}

@Injectable({
  providedIn: "root",
})
export class AlertService {
  constructor(private snackBar: MatSnackBar) {}

  private openCustomSnackbar(message: string, messageType: string, result?: AlertResult) {
    this.snackBar.openFromComponent(AlertComponent, {
      data: {
        message: message,
        messageType: messageType,
        ...result,
      },
      horizontalPosition: "right",
      verticalPosition: "top",
      // a result has more to read, and a link to follow
      duration: result ? 9000 : 5000,
      panelClass: ["snackbar", "app-alert-snackbar"],
    });
  }

  showSuccess(message: string) {
    this.openCustomSnackbar(message, "success");
  }

  showError(message: string) {
    this.openCustomSnackbar(message, "error");
  }

  showWarning(message: string) {
    this.openCustomSnackbar(message, "warning");
  }

  showResult(result: AlertResult) {
    this.openCustomSnackbar(result.detail ?? "", result.tone, result);
  }
}
